export default "__VITE_PUBLIC_ASSET__a21279b7__"